// extracted by mini-css-extract-plugin
export default {"table":"Admin_table__Iw5Xf","color":"Admin_color__-G9V3","sec":"Admin_sec__pfumc"};